<!-- No Data Template -->
<ng-template #no_data_template
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentNoDataContainer(depth)">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeNoDataText">
          {{ 'global.no_data' | translate }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Slide Template -->
<ng-template #slide_template
  let-page="page"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <i [class]="FlatModels.PageEntityModels.PageTypeAndDepthIcon(page.type, 0)"></i>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="page.title">
          {{ page.title }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Slide Layers Template -->
<ng-template #slide_layers_template
  let-templateSlideTree="templateSlideTree"
  let-page="page"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <button medsurf-design-input-button [id]="'slide_layers_toggle_' + page.id"
          [title]="(!typedSlideLayersExpanded[page.id] ? 'global.slide_layers_toggle_open' : 'global.slide_layers_toggle_close') | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [iconClass]="(!typedSlideLayersExpanded[page.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
          [disabled]="page.layers.length === 0"
        (click)="onSlideLayersExpand(page)"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="'global.layers' | translate">
          {{ 'global.layers' | translate }}
        </span>
      </div>
    </div>
    @if (slideAuthorFacade.layers$(page.layers) | async | sortBy_shared:'asc':'position'; as layers) {
      <div [hidden]="!typedSlideLayersExpanded[page.id]"
        [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
        @if (page.layers.length === 0) {
          <ng-container *ngTemplateOutlet="no_data_template;context:{
                        depth: depth + 1}"></ng-container>
        }
        @if (layers.length === 0) {
          @for (i of page.layers; track i) {
            <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
              class="cursor-wait"
              >
            </p-skeleton>
          }
        }
        @if (layers.length > 0) {
          <div>
            @for (layer of layers; track trackByLayer($index, layer)) {
            <ng-container *ngTemplateOutlet="override_layer_template || layer_template;context:{
                          templateSlideTree,
                          layer,
                          depth: depth + 1}">
              </ng-container>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Slide Groups Template -->
<ng-template #slide_groups_template
  let-templateSlideTree="templateSlideTree"
  let-page="page"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <button medsurf-design-input-button [id]="'slide_groups_toggle_' + page.id"
          [title]="(!typedSlideGroupsExpanded[page.id] ? 'global.slide_groups_toggle_open' : 'global.slide_groups_toggle_close') | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [iconClass]="(!typedSlideGroupsExpanded[page.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
          [disabled]="page.groups.length === 0"
        (click)="onSlideGroupsExpand(page)"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="'global.groups' | translate">
          {{ 'global.groups' | translate }}
        </span>
      </div>
    </div>
    @if (slideAuthorFacade.groups$(page.groups) | async | sortBy_shared:'asc':'order'; as groups) {
      <div [hidden]="!typedSlideGroupsExpanded[page.id]"
        [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
        @if (page.groups.length === 0) {
          <ng-container *ngTemplateOutlet="no_data_template;context:{
                        depth: depth + 1}"></ng-container>
        }
        @if (groups.length === 0) {
          @for (i of page.groups; track i) {
            <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
              class="cursor-wait"
              >
            </p-skeleton>
          }
        }
        @if (groups.length > 0) {
          <div>
            @for (group of groups; track trackByGroup($index, group)) {
            <ng-container *ngTemplateOutlet="override_group_template || group_template;context:{
                          templateSlideTree,
                          group,
                          depth: depth + 1}">
              </ng-container>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Slide Questions Template -->
<ng-template #slide_questions_template
  let-templateSlideTree="templateSlideTree"
  let-page="page"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <button medsurf-design-input-button [id]="'slide_questions_toggle_' + page.id"
          [title]="(!typedSlideQuestionsExpanded[page.id] ? 'global.slide_questions_toggle_open' : 'global.slide_questions_toggle_close') | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [iconClass]="(!typedSlideQuestionsExpanded[page.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
          [disabled]="page.questions.length === 0"
        (click)="onSlideQuestionsExpand(page)"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="'global.questions' | translate">
          {{ 'global.questions' | translate }}
        </span>
      </div>
      <!--
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
        <medsurf-design-content-chip>
          <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION"></i>
          {{ page.questions.length }}
        </medsurf-design-content-chip>
      </div>
      -->
    </div>
    @if (slideAuthorFacade.questions$(page.questions) | async | sortBy_shared:'asc':'order'; as questions) {
      <div [hidden]="!typedSlideQuestionsExpanded[page.id]"
        [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
        @if (page.questions.length === 0) {
          <ng-container *ngTemplateOutlet="no_data_template;context:{
                        depth: depth + 1}"></ng-container>
        }
        @if (questions.length === 0) {
          @for (i of page.questions; track i) {
            <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
              class="cursor-wait"
              >
            </p-skeleton>
          }
        }
        @if (questions.length > 0) {
          <div>
            @for (question of questions; track trackByQuestion($index, question)) {
            <ng-container *ngTemplateOutlet="override_question_template || question_template;context:{
                          templateSlideTree,
                          question,
                          depth: depth + 1}">
              </ng-container>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Layer Template -->
<ng-template #layer_template
  let-templateSlideTree="templateSlideTree"
  let-layer="layer"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [id]="'tse-' + layer.id"
      [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <button medsurf-design-input-button [id]="'layer_toggle_' + layer.id"
          [title]="(!typedLayerExpanded[layer.id] ? 'global.layer_toggle_open' : 'global.layer_toggle_close') | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [iconClass]="(!typedLayerExpanded[layer.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
          [disabled]="layer.images.length === 0"
        (click)="onLayerExpand(layer)"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
        <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LAYER"></i>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="layer.window || 'global.window_default' | translate">
          {{ layer.window || 'global.window_default' | translate }}
        </span>
      </div>
    </div>
    @if (slideAuthorFacade.images$(layer.images) | async | sortBy_shared:'asc':'sequenceNumber'; as images) {
      <div [hidden]="!typedLayerExpanded[layer.id]"
        [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
        @if (layer.images.length === 0) {
          <ng-container *ngTemplateOutlet="no_data_template;context:{
                        depth: depth + 1}"></ng-container>
        }
        @if (images.length === 0) {
          @for (i of layer.images; track i) {
            <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
              class="cursor-wait"
              >
            </p-skeleton>
          }
        }
        @if (images.length > 0) {
          <div>
            @for (image of images; track trackByImage($index, image)) {
            <ng-container *ngTemplateOutlet="override_image_template || image_template;context:{
                          templateSlideTree,
                          layer: layer,
                          image: image,
                          depth: depth + 1}">
              </ng-container>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Image Template -->
<ng-template #image_template
  let-templateSlideTree="templateSlideTree"
  let-layer="layer"
  let-image="image"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    @let media = slideAuthorFacade.media$(image.media) | async;
    <div
      [id]="'tse-' + image.id"
      [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <button medsurf-design-input-button [id]="'image_toggle_' + image.id"
          [title]="(!typedImageExpanded[image.id] ? 'global.image_toggle_open' : 'global.image_toggle_close') | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [iconClass]="(!typedImageExpanded[image.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
          [disabled]="image.annotations.length === 0 && image.pois.length === 0"
        (click)="onImageExpand(image)"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentImageContainer">
        <img [style]="FlatModels.TreeDesignModels.TreeDragNodeImageHeightStyle"
          [src]="mediaControlService.getUrl(media, 'thumbnail') || '/assets/images/no-image.png'"
          [alt]="media?.name || 'global.error_loading_image' | translate" />
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="'# '+ image.sequenceNumber + (media?.dimensions?.depth ? ' (' + media?.dimensions?.depth + ')' : '')">
          # {{ image.sequenceNumber }} {{ (media?.dimensions?.depth ? '(' + media?.dimensions?.depth + ')' : '') }}
        </span>
      </div>
      <!--
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
        <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer2">
          <medsurf-design-content-chip [class]="'mr-2'">
            <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"></i>
            {{ image.annotations.length }}
          </medsurf-design-content-chip>
          <medsurf-design-content-chip>
            <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"></i>
            {{ image.pois.length }}
          </medsurf-design-content-chip>
        </div>
      </div>
      -->
    </div>
    <div [hidden]="!typedImageExpanded[image.id]"
      [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
      <ng-container *ngTemplateOutlet="override_image_annotations_template || image_annotations_template,context:{
                    templateSlideTree,
                    image,
                    depth: depth + 1}">
      </ng-container>
      <ng-container *ngTemplateOutlet="override_image_pois_template || image_pois_template,context:{
                    templateSlideTree,
                    image,
                    depth: depth + 1}">
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- Image Annotations Template -->
<ng-template #image_annotations_template
  let-templateSlideTree="templateSlideTree"
  let-image="image"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <button medsurf-design-input-button [id]="'image_annotations_toggle_' + image.id"
          [title]="(!typedImageAnnotationExpanded[image.id] ? 'global.image_annotations_toggle_open' : 'global.image_annotations_toggle_open') | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [iconClass]="(!typedImageAnnotationExpanded[image.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
          [disabled]="image.annotations.length === 0"
        (click)="onImageAnnotationsExpand(image)"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="'global.annotations' | translate">
          {{ 'global.annotations' | translate }}
        </span>
      </div>
      <!--
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
        <medsurf-design-content-chip>
          <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ANNOTATIONS"></i>
          {{ image.annotations.length }}
        </medsurf-design-content-chip>
      </div>
      -->
    </div>
    @if (slideAuthorFacade.annotations$(image.annotations) | async | sortBy_shared:'asc':'sequenceNumber'; as annotations) {
      <div [hidden]="!typedImageAnnotationExpanded[image.id]"
        [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
        @if (image.annotations.length === 0) {
          <ng-container *ngTemplateOutlet="no_data_template;context:{
                        depth: depth + 1}"></ng-container>
        }
        @if (annotations.length === 0) {
          @for (i of image.annotations; track i) {
            <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
              class="cursor-wait"
              >
            </p-skeleton>
          }
        }
        @if (annotations.length > 0) {
          <div>
            @for (annotation of annotations; track trackByAnnotation($index, annotation)) {
            <ng-container *ngTemplateOutlet="override_annotation_template || annotation_template;context:{
                          templateSlideTree,
                          annotation,
                          depth: depth + 1}">
              </ng-container>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Image Pois Template -->
<ng-template #image_pois_template
  let-templateSlideTree="templateSlideTree"
  let-image="image"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <button medsurf-design-input-button [id]="'image_pois_toggle_' + image.id"
          [title]="(!typedImagePoiExpanded[image.id] ? 'global.image_pois_toggle_open' : 'global.image_pois_toggle_open') | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [iconClass]="(!typedImagePoiExpanded[image.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
          [disabled]="image.pois.length === 0"
        (click)="onImagePoisExpand(image)"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="'global.pois' | translate">>
          {{ 'global.pois' | translate }}
        </span>
      </div>
      <!--
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentChipContainer">
        <medsurf-design-content-chip>
          <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"></i>
          {{ image.pois.length }}
        </medsurf-design-content-chip>
      </div>
      -->
    </div>
    @if (slideAuthorFacade.pois$(image.pois) | async | sortBy_shared:'asc':'order'; as pois) {
      <div [hidden]="!typedImagePoiExpanded[image.id]"
        [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
        @if (image.pois.length === 0) {
          <ng-container *ngTemplateOutlet="no_data_template;context:{
                        depth: depth + 1}"></ng-container>
        }
        @if (pois.length === 0) {
          @for (i of image.pois; track i) {
            <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
              class="cursor-wait"
              >
            </p-skeleton>
          }
        }
        @if (pois.length > 0) {
          <div>
            @for (poi of pois; track trackByPoi($index, poi)) {
            <ng-container *ngTemplateOutlet="override_image_poi_template || image_poi_template;context:{
                          templateSlideTree,
                          poi,
                          depth: depth + 1}">
              </ng-container>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Annotation Template -->
<ng-template #annotation_template
  let-templateSlideTree="templateSlideTree"
  let-annotation="annotation"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [id]="'tse-' + annotation.id"
      [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        @if (annotation.type !== FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
          <i
          [class]="FlatModels.AnnotationEntityModels.AnnotationTypeIcon[annotation.type]"></i>
        }
        @if (annotation.type === FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
          <i
          [class]="FlatModels.AnnotationEntityModels.ShapeIcon[annotation.shape]"></i>
        }
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="slideAuthorFacade.annotationLabelInfo$(annotation.id, translate) | async">
          {{ slideAuthorFacade.annotationLabelInfo$(annotation.id, translate) | async }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Group Template -->
<ng-template #group_template
  let-templateSlideTree="templateSlideTree"
  let-group="group"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [id]="'tse-' + group.id"
      [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <button medsurf-design-input-button [id]="'group_toggle_' + group.id"
          [title]="(!typedGroupExpanded[group.id] ? 'global.group_toggle_open' : 'global.group_toggle_close') | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT"
          [iconClass]="(!typedGroupExpanded[group.id] ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.RIGHT : FlatModels.ButtonDesignModels.ButtonDefaultIcons.DOWN)"
          [disabled]="group.annotations.length === 0"
        (click)="onGroupExpand(group)"></button>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentAttributesContainer">
        <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LAYER"
        [style.color]="group.color"></i>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="group.name">
          {{ group.name }}
        </span>
      </div>
    </div>
    @if (slideAuthorFacade.annotations$(group.annotations) | async | sortBy_shared:'asc':'sequenceNumber'; as annotations) {
      <div [hidden]="!typedGroupExpanded[group.id]"
        [class]="FlatModels.TreeDesignModels.TreeDragNodeContentContainer">
        @if (group.annotations.length === 0) {
          <ng-container *ngTemplateOutlet="no_data_template;context:{
                        depth: depth + 1}"></ng-container>
        }
        @if (annotations.length === 0) {
          @for (i of group.annotations; track i) {
            <p-skeleton [height]="FlatModels.TreeDesignModels.TreeDragNodeSkeletonHeight"
              class="cursor-wait"
              >
            </p-skeleton>
          }
        }
        @if (annotations.length > 0) {
          <div>
            @for (annotation of annotations; track trackByAnnotation($index, annotation)) {
            <ng-container *ngTemplateOutlet="override_annotation_template || annotation_template;context:{
                          templateSlideTree,
                          annotation,
                          depth: depth + 1}">
              </ng-container>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Image Poi Template -->
<ng-template #image_poi_template
  let-templateSlideTree="templateSlideTree"
  let-poi="poi"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [id]="'tse-' + poi.id"
      [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"></i>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="poi.name">
          {{ poi.name }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Question Template -->
<ng-template #question_template
  let-templateSlideTree="templateSlideTree"
  let-question="question"
  let-depth="depth">
  <div [class]="FlatModels.TreeDesignModels.TreeDragNode">
    <div [id]="'tse-' + question.id"
      [class]="FlatModels.TreeDesignModels.TreeDragNodeContent">
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentDropDownContainer(depth)">
        <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.QUESTION"></i>
      </div>
      <div [class]="FlatModels.TreeDesignModels.TreeDragNodeContentTitleContainer">
        <span [class]="FlatModels.TreeDesignModels.TreeDragNodeContentText"
          [title]="question.content | stripTags"
          [innerHTML]="question.content | stripTags">
        </span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Menu Template -->
<ng-template #menu_template
  let-templateSlideTree="templateSlideTree"
  let-page="page">
  <div [class]="FlatModels.TreeDesignModels.TreeDragulaNode">
    <ng-container *ngTemplateOutlet="override_slide_template || slide_template,context:{
                  page,
                  depth: 0}"></ng-container>
    <ng-container *ngTemplateOutlet="override_slide_layers_template || slide_layers_template,context:{
                  templateSlideTree,
                  page,
                  depth: 0}"></ng-container>
    <ng-container *ngTemplateOutlet="override_slide_questions_template || slide_questions_template,context:{
                  templateSlideTree,
                  page,
                  depth: 0}"></ng-container>
    <ng-container *ngTemplateOutlet="override_slide_groups_template || slide_groups_template,context:{
                  templateSlideTree,
                  page,
                  depth: 0}"></ng-container>
  </div>
</ng-template>

<!-- Content -->
@if (nodeSharedFacade.currentSelectedSlidePage$ | async; as page) {
  <div class="w-full overflow-hidden"
    >
    <ng-container *ngTemplateOutlet="override_menu_template || menu_template, context: {
                  templateSlideTree: this,
                  page}"></ng-container>
  </div>
}